import { events } from "../../../exports/event-q-bus";
import { EVENTS, type DeviceEvents } from "./events";

/**
 *
 *
 *
 *
 *
 *
 */
export function isTouchable(): boolean {
  if (import.meta.env.SSR) {
    return false;
  }

  const data: [ontouchstart: boolean, documentTouch: boolean, maxTouchPoints: boolean] = [
    "ontouchstart" in window,
    /*                                    */
    !!(window.DocumentTouch && document instanceof window.DocumentTouch),

    !!window.navigator.maxTouchPoints,
  ];

  const isTouchableFlag = data.some(Boolean);
  const { classList } = document.documentElement;

  if (isTouchableFlag) {
    /*                                                                        */
    classList.add("touchable");

    /*                   */
    events<DeviceEvents>().emitRetain(EVENTS[1], {
      documentTouch: data[1],
      maxTouchPoints: data[2],
      ontouchstart: data[0],
    });
  } else {
    classList.add("not-touchable");
  }

  return isTouchableFlag;
}
